import type { EntityOption } from '@/components/EntitySelect';
import { getLead, listLeads } from './api';

/** Server search for the lead picker (EntitySelect). */
export async function searchLeads(query: string): Promise<EntityOption[]> {
  const page = await listLeads({ search: query || undefined });
  return page.results.map((l) => ({ value: String(l.id), label: l.title }));
}

/** Resolve a lead's title for a preselected id (edit mode). */
export async function resolveLeadLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const lead = await getLead(Number(value));
  return lead.title;
}
